export default "__VITE_ASSET__B40x20Ej__"